<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select v-if="!isHide('Facility')" :readonly="readonlyFacility" :items="form.facilitiesDisplay" v-model="form.facilityDisplay" @change="facilityChanged" :label="$t('Facility')" :rules="(isRequired('Facility') ? [rules.required] : [])"></v-select>

                <v-autocomplete v-if="!isHide('Vehicle')" :readonly="isReadonly('Vehicle')" :disabled="readonlyVehicle" :items="form.vehicles" v-model="form.vehicleNo" @change="vehicleChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Vehicle')" :rules="(isRequired('Vehicle') ? [rules.required] : [])" @focus="focusVehicle" :no-data-text="ct.NoDataAvailable"></v-autocomplete>
                <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Agreement')" :readonly="isReadonly('Agreement')" :items="form.agreements" v-model="form.agreementNo" :label="$t('Agreement')" @change="agreementChanged" v-on:keyup="searchAgreement = $event.target.value" @keyup="searchDelayedAgreement" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
                <v-progress-linear v-if="searchingAgreement" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Delivery')" :readonly="isReadonly('Delivery')" :items="form.deliveries" v-model="form.deliveryNo" :label="$t('Delivery')" @change="deliveryChanged" :disabled="!form.agreementNo" :rules="(isRequired('Delivery') ? [rules.required] : [])" :no-data-text="ct.NoDataAvailable"></v-autocomplete>

                <v-autocomplete v-if="!isHide('Customer')" :readonly="isReadonly('Customer')" :items="form.customers" v-model="form.customerNo" v-on:keyup="searchCustomer = $event.target.value" @keyup="searchDelayedCustomer" :label="$t('Customer')" :rules="(isRequired('Customer') ? [rules.required] : [])"></v-autocomplete>
                <v-progress-linear v-if="searchingCustomer" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Article')" :readonly="isReadonly('Article')" :items="form.articles" v-model="form.articleNo" @change="articleChanged" :label="$t('Article')" :rules="(isRequired('Article') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Carrier')" :readonly="isReadonly('Carrier')" :items="form.carriers" v-model="form.carrierNo" :label="$t('Carrier')" :rules="(isRequired('Carrier') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('RequisitionNo1')" :readonly="isReadonly('RequisitionNo1')" v-model="form.requisitionNo1" :label="$t('RequisitionNo1')" :rules="(isRequired('RequisitionNo1') ? [rules.required] : [])"></v-text-field>
                <v-text-field v-if="!isHide('RequisitionNo2')" :readonly="isReadonly('RequisitionNo2')" v-model="form.requisitionNo2" :label="$t('RequisitionNo2')" :rules="(isRequired('RequisitionNo2') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHide('Plant')" :readonly="isReadonly('Plant')" :items="form.plants" v-model="form.plantNo" :label="$t('Plant')" :rules="(isRequired('Plant') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('Comment')" :readonly="isReadonly('Comment')" v-model="form.comment1" :label="$t('Comment')" :maxlength="100" :rules="(isRequired('Comment') ? [rules.required] : [])"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="saving" min-width="97px" :disabled="!valid" @click="save" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Archive from '@/core/archive'
import * as PreRegistration from '@/modules/pre-registration/pre-registration'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import { validSearchKeyUp } from '@/core/utils'
import _ from 'lodash' // clone

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'pre-registration-registration',
    loading: true,
    saving: false,
    readonlyFacility: true, // Prevent errors: true when editing registration, false when creating new registration
    hiddenFields: [],
    readonlyFields: [],
    requiredFields: [],
    valid: true,
    redirectTo: 'pre-registration-registrations',
    searchVehicle: '',
    searching: false,
    searchAgreement: '',
    searchingAgreement: false,
    searchCustomer: '',
    searchingCustomer: false,
    searchTimer: null,
    readonlyVehicle: false, // Prevent errors: do not allow vehicle change for pre-reg user with licensplate
    articleNoFilter: null,
    useFacilityDescription: false,
    agreementNoFilter: null,
    form: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      facilityNo: '',
      facilitiesDescription: [],
      facilityDescription: '',
      facilityDisplay: '',
      facilitiesDisplay: [],
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      top: 100
    },
    preReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      Id: '00000000-0000-0000-0000-000000000000',
      Facility: null
    },
    userVehicleLicensePlateNo: null
  }),
  methods: {
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 600)
      }
    },
    searchDelayedCustomer (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchCustomers, 600)
      }
    },
    searchDelayedAgreement (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreements, 600)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 1) this.form.vehicles = []
      // Temporary show Search vehicle xxx ....
      this.form.vehicles = [this.searchVehicle.length ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle) this.updateVehicles(this.searchVehicle)
    },
    searchCustomers () {
      if (this.searchCustomer.length < 1) this.form.customers = []
      // Temporary show Search customer xxx ....
      this.form.customers = [this.searchCustomer.length ? this.$t('Searching') + ' ' + this.searchCustomer + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchCustomer) this.updateCustomers(this.searchCustomer)
    },
    searchAgreements () {
      if (this.searchAgreement.length < 1) this.form.agreements = []
      // Temporary show Search agreement xxx ....
      this.form.agreements = [this.searchAgreement.length ? this.$t('Searching') + ' ' + this.searchAgreement + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreement) this.updateAgreements(this.searchAgreement)
    },
    focusVehicle () {
      // Temporary show Search
      if (this.form.vehicles.length !== 1) this.form.vehicles = [this.$t('Search')]
    },
    async updateVehicles (search) {
      this.searching = true

      // "search" for one vehicle (single lookup)
      if (search.length === 1) {
        const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search, loadDeleted: false })
        if (!res.failed) {
          if (res.data) {
            const item = res.data
            this.form.vehicles = [{
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }]
          } else {
            this.form.vehicles = []
          }
        }
      } else { // search for many vehicles (via searchText)
        const res = await Archive.loadVehicles({ facility: this.form.facilityNo, searchText: search, loadDeleted: false })
        if (!res.failed) {
          this.form.vehicles = res.data.map(item => {
            return {
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }
          })
          // if logged in user has LicensPlate - always use it's No in the readonly vehicle field
          if (this.userVehicleLicensePlateNo && this.form.vehicles.length === 1) {
            this.form.vehicleNo = this.form.vehicles[0].obj.No
            // fire a change so all fields are updated according to userVehicleLicensePlateNo
            this.$root.$emit('changeVehicle', this.form.vehicleNo)
          }
        }
      }

      this.searching = false
    },
    async updateAgreements (search) {
      this.searchingAgreement = true
      const res = await Archive.loadAgreements({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searchingAgreement = false
    },
    async updateCustomers (search) {
      this.searchingCustomer = true
      const res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searchingCustomer = false
    },
    async loadVehicle (search) {
      const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
      if (!res.failed) {
        if (res.data) {
          const item = res.data
          this.form.vehicles = [{
            text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }]
          this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
          this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
          this.loadFilteredArticles()
          this.loadAgreement(this.form.agreementNo)
        }
      }
    },
    // this.articleNoFilter comes from the selected Vehicles or Agreement DetailValidArticles when Valid Choice is installed and some few Articles are selected on the Vehicle/Agreement,
    // else null that will return all (non-deleted) Articles
    async loadFilteredArticles () {
      const res = await PreRegistration.loadFilteredArticles({ facilityNo: this.form.facilityNo, ArticleNoFilter: this.articleNoFilter })
      if (!res.failed) {
        this.form.articles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async loadAgreement (number) {
      const res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: number, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },

    async updateUi () {
      this.form.facilities = [this.$t('Loading ...')]
      this.form.facilitiesDescription = [this.$t('Loading ...')]
      this.form.agreements = [this.$t('Loading ...')]
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.customers = [this.$t('Loading ...')]
      this.form.articles = [this.$t('Loading ...')]
      this.form.carriers = [this.$t('Loading ...')]
      this.form.plants = [this.$t('Loading ...')]
      let res = await Archive.loadFacilities(true)
      const facilitiesResDescription = _.cloneDeep(res)
      if (!res.failed) {
        const noGlobal = res.data.filter(o => o.No !== '')
        this.form.facilities = noGlobal.map(item => {
          return {
            text: item.No,
            value: item.No,
            obj: item
          }
        })
        this.form.facilitiesDisplay = this.form.facilities
        if (this.useFacilityDescription) {
        // const facilitiesRes2 = await Archive.loadFacilities()
          var d = facilitiesResDescription.data
          if (!d.includes('')) d.unshift({ No: '', Description: '' })
          const noGlobal2 = d.filter(o => o.No !== '')
          this.form.facilitiesDescription = noGlobal2.map(item => {
            return {
              text: item.Description,
              value: item.Description,
              item: item
            }
          })

          this.form.facilitiesDisplay = this.form.facilitiesDescription
        }

        if (this.useFacilityDescription) {
          if (this.form.facilitiesDescription.length > 0) {
            if (this.form.facilityNo === null || this.form.facilityNo === 'null') {
              this.form.facilityDisplay = ''
            } else {
              this.form.facilityDisplay = this.form.facilitiesDescription.find(f => f.item.No === this.form.facilityNo).value
            }
          }
        }
      }

      res = await Archive.loadCarriers(this.form.facilityNo)
      if (!res.failed) {
        this.form.carriers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadPlants(this.form.facilityNo)
      if (!res.failed) {
        this.form.plants = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.reloadCustomers()

      // Load Filtered Articles via Vehicle ValidArticles
      this.loadFilteredArticles()

      // Load only agreementNo into list
      this.form.searchCriteria = this.form.agreementNo
      res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: this.form.agreementNo, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.updateDeliveries()

      // Force validation of all fields to show requrired
      if (this.$refs.form && !this.$refs.form.validate()) this.valid = false

      this.$forceUpdate()
    },
    async reloadCustomers () {
      this.form.searchCriteria = this.form.customerNo
      const res = await Archive.loadCustomer({ facilityNo: this.form.facilityNo, customerNo: this.form.searchCriteria })
      if (!res.failed) {
        const item = res.data
        this.form.customers = [{
          text: [item.No, item.Name].filter(Boolean).join(' - '),
          value: item.No,
          obj: item
        }]
      }
    },
    async updateDeliveries () {
      const res = await Archive.loadDeliveries({ facilityNo: this.form.facilityNo, agreementId: this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Id') })
      if (!res.failed) {
        this.form.deliveries = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
        // Clear old value if not in new deliveries
        if (!this.form.deliveries.find(d => d.value === this.form.deliveryNo)) this.form.deliveryNo = ''
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.form.facilitiesDisplay.find(f => f.value === this.form.facilityDisplay)
        if (facilityDisplay != null) {
          this.form.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.form.facilityNo = this.form.facilityDisplay
      }
      this.preventLeave = false
      if (this.form.facilityNo != null) LocalStorage.save('facilityNo', this.form.facilityNo)
      this.form.vehicleNo = ''
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''
      this.updateUi()
      if (this.userVehicleLicensePlateNo.toString() !== '') {
        this.updateVehicles(this.userVehicleLicensePlateNo)
      }
    },
    async deliveryChanged () {
      this.preventLeave = false

      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelPlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCustomerNo')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }

      this.$forceUpdate()
    },
    async agreementChanged () {
      this.preventLeave = false
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.deliveryNo = ''
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CustomerNo')

      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ValidArticles')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }

      this.updateDeliveries()
      this.loadFilteredArticles()
      this.$forceUpdate()
    },
    async vehicleChanged () {
      // Fix selecting "Search" by accident
      if ((!this.form.vehicleNo && this.form.vehicles.length !== 1) || (this.form.vehicleNo && this.form.vehicleNo.includes(this.$t('Search')))) {
        this.form.vehicles = []
        this.form.vehicleNo = ''
        this.searchVehicle = ''
      }

      this.preventLeave = false
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CustomerNo')
      var deliveryNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'DeliveryNo')
      var agreementNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'AgreementNo')

      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
      this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }
      if (agreementNo) { this.form.agreementNo = agreementNo; this.agreementChanged() }
      if (deliveryNo) { this.form.deliveryNo = deliveryNo; this.deliveryChanged() }

      this.loadFilteredArticles()
      this.loadAgreement(this.form.agreementNo)

      this.$forceUpdate()
    },
    async articleChanged () {
      this.preventLeave = false
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.articles, this.form.articleNo, 'Details'), 'PlantNo')
      if (plantNo) this.form.plantNo = plantNo
      this.$forceUpdate()
    },
    // async tst () {
    //   // this.$root.$message.showSuccess(this.$t("tst:"+this.form.article))
    //   /* console.log('---->> this.form.vehicleNo:', this.form.vehicleNo, this.form.articleNo)
    //   console.log('---->> LicensePlateNo:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo'))
    //   console.log('---->> Name:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name'))
    //   console.log('---->> Art:', this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name'))
    //   console.log('---->> Lists:', this.form.articles, this.form.vehicles) */
    // },
    getItemFromArray (array, findNo, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.obj.No === findNo)
        if (found) {
          // item exists
          result = found.obj[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getData1FromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Data1
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    isReadonly (fieldName) {
      return this.readonlyFields.some(h => h === fieldName)
    },
    isRequired (fieldName) {
      return this.requiredFields.some(h => h === fieldName)
    },
    formToObject () {
      this.preReg.Facility = this.form.facilityNo
      this.preReg.facilityNo = this.form.facilityNo

      this.preReg.VehicleNo = this.form.vehicleNo
      this.preReg.VehicleName = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name')
      this.preReg.VehicleLicensePlateNo = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo')
      this.preReg.AgreementNo = this.form.agreementNo
      this.preReg.AgreementName = this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Name')
      this.preReg.DeliveryNo = this.form.deliveryNo
      this.preReg.DeliveryName = this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Name')
      this.preReg.CustomerNo = this.form.customerNo
      this.preReg.CustomerName = this.getItemFromArray(this.form.customers, this.form.customerNo, 'Name')
      this.preReg.ArticleNo = this.form.articleNo
      this.preReg.ArticleName = this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name')
      this.preReg.PlantNo = this.form.plantNo
      this.preReg.PlantName = this.getItemFromArray(this.form.plants, this.form.plantNo, 'Name')
      this.preReg.CarrierNo = this.form.carrierNo
      this.preReg.CarrierName = this.getItemFromArray(this.form.carriers, this.form.carrierNo, 'Name')
      this.preReg.RequisitionNo1 = this.form.requisitionNo1
      this.preReg.RequisitionNo2 = this.form.requisitionNo2
      this.preReg.Comment1 = this.form.comment1
    },
    async save () {
      this.preventLeave = false
      if (this.$refs.form.validate()) {
        this.saving = true
        this.formToObject()
        const res = await PreRegistration.saveRegistration(this.preReg)
        this.saving = false
        if (!res.failed) {
          this.$root.$message.showSuccess(this.$t('Saved'))
          this.preventLeave = false
          this.$router.push({ name: this.redirectTo })
        }
      }
    }
  },
  beforeDestroy () {
    // Unsubscribe to event listener for events from LoadVehicles(), when only ONE vehicle exist. Update all other details for this vehicle
    this.$root.$off('changeVehicle', this.callVehicleChange)
  },
  async mounted () {
    // Update all other details for this vehicle, only when ONE vehicle exist
    this.callVehicleChange = () => { this.vehicleChanged() }

    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }

    // load Users VehicleLicensePlateNo - if any - and filter/fix the Vehicles drop down field. If no VehicleLicensePlateNo show all Vehicles.
    const res = await PreRegistration.userVehicleLicensePlateNo()
    if (!res.failed) {
      this.userVehicleLicensePlateNo = res.data.userVehicleLicensePlateNo
    }

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_Fields_Hidden')?.Data1 ?? '').split(',')
      this.readonlyFields = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_Fields_ReadOnly')?.Data1 ?? '').split(',')
      this.requiredFields = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_Fields_Mandatory')?.Data1 ?? '').split(',')
    }

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    if (this.$route.params.id) {
      this.readonlyFacility = true // never allow change on Edit
      this.preReg.id = this.$route.params.id
      const res = await PreRegistration.loadRegistration(this.preReg.id)
      this.preReg.Id = this.preReg.id
      if (!res.failed) {
        this.form.facilityNo = res.data.Facility

        this.updateUi()

        this.form.vehicleNo = res.data.VehicleNo
        this.form.agreementNo = res.data.AgreementNo
        // Load only this vehicle into form.vehicles so LicensPlate is visible and dropdown works
        if (this.form.vehicleNo) { this.loadVehicle(this.form.vehicleNo) } else this.form.vehicles = [this.$t('Search')]
        if (this.userVehicleLicensePlateNo) this.readonlyVehicle = true

        this.form.vehicleName = res.data.VehicleName
        this.form.vehicleLicensePlateNo = res.data.VehicleLicensePlateNo
        this.form.deliveryNo = res.data.DeliveryNo
        this.form.customerNo = res.data.CustomerNo
        this.form.articleNo = res.data.ArticleNo
        this.form.plantNo = res.data.PlantNo
        this.form.carrierNo = res.data.CarrierNo
        this.form.requisitionNo1 = res.data.RequisitionNo1
        this.form.requisitionNo2 = res.data.RequisitionNo2
        this.form.comment1 = res.data.Comment1
        console.log('pip', this.form.facilitiesDescription)
        if (!this.useFacilityDescription) {
          this.form.facilityDisplay = this.form.facilityNo
        } else {
          /* if (this.form.facilitiesDescription.length > 0) {
            this.form.facilityDisplay = this.form.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
          } */
        }
        this.preReg.registrationId = res.data.RegistrationId
        this.preReg.facilityNo = res.data.Facility
        this.preReg.finishedDate = res.data.FinishedDate
        this.preReg.finishedBy = res.data.FinishedBy
        this.preReg.comment = res.data.Comment
        this.preReg.preStatus = res.data.PreStatus
      }
    } else {
      this.readonlyFacility = this.isReadonly('Facility') // can be setup ReadOnly
      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) this.form.facilityNo = storedFacilityNo
      if (!this.useFacilityDescription) {
        this.form.facilityDisplay = this.form.facilityNo
      } else {
        if (this.form.facilitiesDescription.length > 0) {
          this.form.facilityDisplay = this.form.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
        }
      }
      // Only update vehicles on startup if user has LicensePlateNo, and disable Vehicles for further input
      if (this.userVehicleLicensePlateNo) {
        this.updateVehicles(this.userVehicleLicensePlateNo)
        this.readonlyVehicle = true
      }
      this.updateUi()
    }

    this.$nextTick(() => {
      this.loading = false
    })

    // Subscribe to event listener for events from LoadVehicles(), when only ONE vehicle exist.
    // To auto update all other details for this vehicle
    this.$root.$on('changeVehicle', this.callVehicleChange)
  }
}
</script>
